import { cn } from '@/lib/utils';
import type { DigitalChipDto } from '@/types/dto';

type Props = {
  chips: DigitalChipDto[];
  value: string;
  onChange: (key: string) => void;
};

export function SourceChips({ chips, value, onChange }: Props) {
  return (
    <div className="flex flex-wrap gap-2 mt-2">
      {chips.map((c) => {
        const active = value === c.key;
        return (
          <button
            key={c.key}
            type="button"
            onClick={() => onChange(c.key)}
            className={cn(
              'font-(family-name:--font-ui) text-[0.72rem] font-medium uppercase tracking-[0.15em]',
              'px-3 py-2 rounded-(--radius-sm) border transition-colors min-h-11',
              active
                ? 'bg-accent text-inverse border-accent'
                : 'bg-surface-elevated text-muted border-border hover:text-text hover:border-accent'
            )}
          >
            {c.label} <span className={active ? 'text-inverse/70' : 'text-muted'}>{c.count}</span>
          </button>
        );
      })}
    </div>
  );
}
